(function(){
  'use strict';
  // Fallback color map for cards rendered without the ns-color-swatches snippet.
  var COLOR_MAP = {
    'sunburst': '#ffc94a',
    'black ice': '#1a1a1a',
    'snow': '#ffffff',
    'sand': '#d4be95',
    'forest': '#1f4d2c',
    'asphalt': '#b8b8b8',
    'purple rain': '#c4a8d8',
    'pink cloud': '#f8c8d6',
    'northern lights': '#a3d9a5'
  };
  function colorFromName(name) {
    if (!name) return null;
    var key = String(name).toLowerCase().trim();
    if (COLOR_MAP[key]) return COLOR_MAP[key];
    var s = new Option().style;
    s.color = key;
    if (s.color) return key;
    return null;
  }
  // Find the card-wrapper that this swatch should control, even if the swatch
  // lives outside it (e.g. rendered by ns-color-swatches snippet as a sibling).
  function findCard(btn) {
    var card = btn.closest('.card-wrapper');
    if (card) return card;
    var item = btn.closest('.grid__item, li');
    if (item) return item.querySelector('.card-wrapper');
    return null;
  }
  // Click handler — runs in capture phase to beat any link navigation.
  document.addEventListener('click', function(e) {
    var btn = e.target && e.target.closest && e.target.closest('.ns-card-swatch, .ns-swatch');
    if (!btn) return;
    if (!btn.getAttribute('data-variant-image') && !btn.getAttribute('data-variant-url')) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    var card = findCard(btn);
    if (!card) return;
    var newSrc = btn.getAttribute('data-variant-image');
    if (newSrc) {
      var img = card.querySelector('.card__media img');
      if (img) {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = newSrc;
      }
    }
    var newUrl = btn.getAttribute('data-variant-url');
    if (newUrl) {
      card.querySelectorAll('a.full-unstyled-link, a[href*="/products/"]').forEach(function(a){
        a.href = newUrl;
      });
    }
    // Active state — update siblings only within the same swatch group.
    var group = btn.parentElement;
    if (group) {
      group.querySelectorAll('.ns-card-swatch, .ns-swatch').forEach(function(s){
        s.classList.remove('is-active');
        s.setAttribute('aria-pressed','false');
      });
    }
    btn.classList.add('is-active');
    btn.setAttribute('aria-pressed','true');
  }, true);

  // Fallback: auto-render swatches on cards that don't already have any
  // (e.g. featured-collection on the homepage where the snippet isn't used).
  var css = '.ns-card-swatches-auto{position:relative;z-index:100;display:flex;flex-wrap:wrap;gap:.6rem;margin:.8rem 0 .4rem;align-items:center;pointer-events:auto}'
    + '.ns-card-swatches-auto .ns-card-swatch{position:relative;z-index:100;pointer-events:auto;width:1.4rem;height:1.4rem;padding:0;border-radius:50%;'
    + 'border:1px solid rgba(0,0,0,.25);background:var(--swatch-bg,#ccc) center/cover;cursor:pointer;transition:transform .15s ease,box-shadow .15s ease}'
    + '.ns-card-swatches-auto .ns-card-swatch:hover{transform:scale(1.2)}'
    + '.ns-card-swatches-auto .ns-card-swatch.is-active{box-shadow:0 0 0 1px #fff,0 0 0 3px #111}';
  var styleEl = document.createElement('style');
  styleEl.textContent = css;
  document.head.appendChild(styleEl);
  var cache = {};
  function fetchProduct(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function(r){ return r.ok ? r.json() : Promise.reject(); });
    return cache[handle];
  }
  function findColorOptionIndex(opts) {
    var names = ['färg','farg','color','colour'];
    for (var i = 0; i < opts.length; i++) {
      if (names.indexOf(String(opts[i]).toLowerCase()) !== -1) return i;
    }
    return -1;
  }
  function resizeImg(url, width) {
    if (!url) return '';
    return url.replace(/(\.(?:jpg|jpeg|png|gif|webp))(\?.*)?$/i, '_' + width + 'x$1$2');
  }
  function buildSwatches(card, productData) {
    if (!productData || !productData.options) return;
    var idx = findColorOptionIndex(productData.options);
    if (idx === -1) return;
    var seen = {};
    var swatches = [];
    for (var i = 0; i < productData.variants.length; i++) {
      var v = productData.variants[i];
      var cv = v.options[idx];
      if (seen[cv]) continue;
      seen[cv] = true;
      swatches.push({ name: cv, variant: v, image: v.featured_image });
    }
    if (swatches.length < 2) return;
    var container = document.createElement('div');
    container.className = 'ns-card-swatches-auto';
    container.setAttribute('role','group');
    container.setAttribute('aria-label', productData.options[idx]);
    swatches.forEach(function(s, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ns-card-swatch' + (i === 0 ? ' is-active' : '');
      btn.setAttribute('aria-label', s.name);
      btn.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
      btn.setAttribute('data-variant-id', s.variant.id);
      btn.setAttribute('data-variant-image', resizeImg(s.image, 720));
      btn.setAttribute('data-variant-url', '/products/' + productData.handle + '?variant=' + s.variant.id);
      var color = colorFromName(s.name);
      btn.style.setProperty('--swatch-bg', color || '#ccc');
      container.appendChild(btn);
    });
    var allContent = card.querySelectorAll('.card__content');
    var content = allContent[allContent.length - 1];
    if (!content) return;
    var info = content.querySelector('.card__information');
    if (info) content.insertBefore(container, info);
    else content.insertBefore(container, content.firstChild);
  }
  function processCard(card) {
    if (card.dataset.nsSwatchesDone) return;
    card.dataset.nsSwatchesDone = '1';
    // Skip if snippet-rendered swatches already exist somewhere in the same grid item / wrapper area
    var scope = card.closest('.grid__item, li') || card;
    if (scope.querySelector('.ns-card-swatch, .ns-swatch[data-variant-image]')) return;
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return;
    var m = link.getAttribute('href').match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    fetchProduct(m[1]).then(function(data){ buildSwatches(card, data); }).catch(function(){});
  }
  function scan() {
    document.querySelectorAll('.card-wrapper').forEach(processCard);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  var observer = new MutationObserver(function(mutations){
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes && mutations[i].addedNodes.length) { scan(); break; }
    }
  });
  if (document.body) observer.observe(document.body, { childList: true, subtree: true });
  else document.addEventListener('DOMContentLoaded', function(){
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
